// ============================================================================
// post-client-mod -- useSearchPosts Hook
//
// 搜索文章，支持关键词、分类、标签过滤。
// ============================================================================
import { useState, useEffect, useCallback, useRef } from 'react';
import { getPostApiClient } from '../post-api-client.js';
/**
 * 搜索文章
 */
export function useSearchPosts(params) {
    const { q, categorySlug, tagSlug, pageSize = 20 } = params;
    const [posts, setPosts] = useState([]);
    const [pagination, setPagination] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(params.page ?? 1);
    const isFirstRender = useRef(true);
    const fetchPosts = useCallback(async () => {
        // 空关键词不搜索
        if (!q.trim()) {
            setPosts([]);
            setPagination(null);
            setLoading(false);
            return;
        }
        // 首次渲染跳过（如果有 initialData 场景）
        if (isFirstRender.current) {
            isFirstRender.current = false;
        }
        setLoading(true);
        setError(null);
        try {
            const result = await getPostApiClient().searchPosts({
                q: q.trim(),
                page,
                pageSize,
                categorySlug,
                tagSlug,
            });
            setPosts(result.data);
            setPagination(result.pagination);
        }
        catch (err) {
            const message = err instanceof Error ? err.message : '搜索失败';
            setError(message);
            setPosts([]);
            setPagination(null);
        }
        finally {
            setLoading(false);
        }
    }, [q, page, pageSize, categorySlug, tagSlug]);
    useEffect(() => {
        fetchPosts();
    }, [fetchPosts]);
    return {
        posts,
        pagination,
        loading,
        error,
        refresh: fetchPosts,
        setPage,
    };
}
//# sourceMappingURL=use-search-posts.js.map